module.exports = __webpack_public_path__ + "static/media/sign_up_img.6b514060.png";